import { Skeleton, Box, Paper, Container, Group } from "@mantine/core"
import React from "react"

// ----------------------------------------------------------------------

export function ArticleDetailsSkeleton(): React.JSX.Element {
  return (
    <Container size="xl" mt={48} mb={64}>
      <Group position="center" mb={48}>
        <Skeleton height={44} width={288}/>
      </Group>

      <Paper>
        <Skeleton height={320} width="100%" radius="xl"/>

        <Container p={0}>
          <Group mt={48}>
            <Skeleton height={36} width={240} radius="xl"/>
            <Skeleton height={36} width={160} radius="xl"/>
          </Group>

          <Box mt={48}>
            {new Array(20).fill(null).map((_, index) => (
              <Skeleton key={index} height={12} mt="xs" width={`${Math.floor(Math.random() * (100 - 45) + 45)}%`}/>
            ))}
          </Box>
        </Container>
      </Paper>
    </Container>
  )
}
